import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteTopicsFulfilledAction } from '../../domains/checkedTopicsFromDiscoveryTopics/deleteTopicsActions.types';
import type { SuggestedTopicsLoadAction } from '../../domains/suggestedTopics/loadActions.types';
import type { SuggestedTopicsLoadMoreAction } from '../../domains/suggestedTopics/loadMoreActions.types';
import type { DismissSuggestedTopicAction } from '../../domains/topicSuggestedDismiss/actions.types';
import type { Topic } from '../types';

import type { ViewerSuggestedTopics } from './types';

export const initialState: ViewerSuggestedTopics = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreSuggestedTopicFulfilled = (
  state: ViewerSuggestedTopics,
  viewerSuggestedTopics: { readonly suggestedTopicIds: string[] }
) =>
  setFulfilled({
    suggestedTopicIds: [
      ...new Set([...(state.fulfilled?.suggestedTopicIds || []), ...viewerSuggestedTopics.suggestedTopicIds]),
    ],
  });

const removeSuggestedTopic = (state: ViewerSuggestedTopics, topicIds: Topic['id'][]) => {
  const currentSuggestedTopicsIds = state.fulfilled?.suggestedTopicIds ?? [];

  if (currentSuggestedTopicsIds.length === 0) {
    return state;
  }

  const suggestedTopicIds = currentSuggestedTopicsIds.filter((topicId) => !topicIds.includes(topicId));

  return setFulfilled({ suggestedTopicIds });
};

export type SuggestedTopicsAction =
  | SuggestedTopicsLoadAction
  | SuggestedTopicsLoadMoreAction
  | DismissSuggestedTopicAction
  | DeleteTopicsFulfilledAction;

const reducer: Reducer<ViewerSuggestedTopics, SuggestedTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_TOPICS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_TOPICS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerSuggestedTopics);
    case 'SUGGESTED_TOPICS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_TOPICS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedTopicFulfilled(state, action.payload.entities.viewerSuggestedTopics);
    case 'TOPIC_SUGGESTED.DISMISS_FULFILLED':
      return removeSuggestedTopic(state, [action.payload.topicId]);
    case 'TOPIC_SUGGESTED.DISMISS_REJECTED':
      return setRejected(action.payload.error);
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.DELETE_TOPICS_FULFILLED':
      return removeSuggestedTopic(state, action.payload.topicIds);
    default:
      return state;
  }
};

export default reducer;
